import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import React from "react";

import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExitToApp from "@mui/icons-material/ExitToApp";
import PersonIcon from "@mui/icons-material/Person";
import LoginIcon from "@mui/icons-material/Login";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import GavelIcon from "@mui/icons-material/Gavel";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

function TopNav(props) {
  // redux hooks
  const { auth } = useSelector((state) => state.customerAuth);
  const location = useLocation();
  const logOut = props.logOut;
  const [openProfile, setOpenProfile] = React.useState(false);
  const openMenu = props.Open;

  const styleList = !openMenu
    ? { alignItems: "center", display: "contents" }
    : { alignItems: "", display: "" };

  const selectedMenu = (route) => {
    return location.pathname === route ? `panel-link-row` : null;
  };

  return (
    <>
      {" "}
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          bgcolor: "background.paper",
        }}
        component="nav"
        dir="ltr"
        aria-labelledby="nested-list-subheader"
      >
        <Link to="/" className="panel-link">
          <ListItemButton className={selectedMenu("/")}>
            {openMenu ? <ListItemText primary="خانه" /> : ""}
            <ListItemIcon style={styleList}>
              <HomeIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>
        {auth.isAuthenticated ? (
          <>
            <ListItemButton onClick={() => setOpenProfile(!openProfile)}>
              {openMenu ? (
                openProfile ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )
              ) : (
                ""
              )}
              {openMenu ? <ListItemText primary=" پروفایل  " /> : ""}

              <ListItemIcon style={styleList}>
                <PersonIcon className="ms-auto" />
              </ListItemIcon>
            </ListItemButton>
            {openMenu ? (
              <Collapse in={openProfile} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Link to="/likes" className="panel-link">
                    <div className="marginRight">
                      <ListItemButton className={selectedMenu("/likes")}>
                        <ListItemText primary=" پسند شده ها" />
                        <ListItemIcon style={styleList}>
                          <FavoriteIcon className="ms-auto" />
                        </ListItemIcon>
                      </ListItemButton>
                    </div>
                  </Link>
                  <Link to="/saved" className="panel-link">
                    <div className="marginRight">
                      <ListItemButton className={selectedMenu("/saved")}>
                        <ListItemText primary=" ذخیره شده ها" />
                        <ListItemIcon style={styleList}>
                          <BookmarkIcon className="ms-auto" />
                        </ListItemIcon>
                      </ListItemButton>
                    </div>
                  </Link>
                  <Link to="/address" className="panel-link">
                    <div className="marginRight">
                      <ListItemButton className={selectedMenu("/address")}>
                        <ListItemText primary="  نشانی ها" />
                        <ListItemIcon style={styleList}>
                          <ContactMailIcon className="ms-auto" />
                        </ListItemIcon>
                      </ListItemButton>
                    </div>
                  </Link>
                  <Link to="/orders" className="panel-link">
                    <div className="marginRight">
                      <ListItemButton className={selectedMenu("/orders")}>
                        <ListItemText primary="  سفارش ها" />
                        <ListItemIcon style={styleList}>
                          <LocalMallIcon className="ms-auto" />
                        </ListItemIcon>
                      </ListItemButton>
                    </div>
                  </Link>
                  <Link to="/ticket" className="panel-link">
                    <div className="marginRight">
                      <ListItemButton className={selectedMenu("/ticket")}>
                        <ListItemText primary=" پشتیبانی" />
                        <ListItemIcon style={styleList}>
                          <SupportAgentIcon className="ms-auto" />
                        </ListItemIcon>
                      </ListItemButton>
                    </div>
                  </Link>
                </List>
              </Collapse>
            ) : (
              ""
            )}
          </>
        ) : (
          <Link to="/login" className="panel-link">
            <ListItemButton className={`${selectedMenu("/login")} panel-link`}>
              {openMenu ? <ListItemText primary="ورود" /> : ""}
              <ListItemIcon style={styleList}>
                <LoginIcon className="ms-auto" />
              </ListItemIcon>
            </ListItemButton>
          </Link>
        )}
        <a
          href="https://blog.meshirt.ir"
          rel="noreferrer"
          target="_blank"
          className="panel-link"
        >
          <ListItemButton>
            {openMenu ? <ListItemText primary=" بلاگ" /> : ""}
            <ListItemIcon style={styleList}>
              <NewspaperIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </a>
        {auth.isAuthenticated ? (
          <Link to="/basket" className="panel-link">
            <ListItemButton className={selectedMenu("/basket")}>
              {openMenu ? <ListItemText primary="سبد خرید" /> : ""}
              <ListItemIcon style={styleList}>
                <ShoppingCartIcon className="ms-auto" />
              </ListItemIcon>
            </ListItemButton>
          </Link>
        ) : (
          <Link to="/login" className="panel-link">
            <ListItemButton className={`${selectedMenu("/basket")} panel-link`}>
              {openMenu ? <ListItemText primary=" سبد خرید " /> : ""}
              <ListItemIcon style={styleList}>
                <ShoppingCartIcon className="ms-auto" />
              </ListItemIcon>
            </ListItemButton>
          </Link>
        )}
        <Link to="/search" className="panel-link">
          <ListItemButton className={selectedMenu("/search")}>
            {openMenu ? <ListItemText primary=" جستجو" /> : ""}
            <ListItemIcon style={styleList}>
              <SearchIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>

        <Link to="/terms" className="panel-link">
          <ListItemButton className={selectedMenu("/terms")}>
            {openMenu ? <ListItemText primary="قوانین" /> : ""}
            <ListItemIcon style={styleList}>
              <GavelIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>
        {auth.isAuthenticated ? (
          <ListItemButton className="text-danger" onClick={logOut}>
            {openMenu ? <ListItemText primary="خروج" /> : ""}

            <ListItemIcon style={styleList}>
              <ExitToApp className="ms-auto text-danger" />
            </ListItemIcon>
          </ListItemButton>
        ) : null}
        <a
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=433310&Code=l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
        >
          <img
            referrerpolicy="origin"
            src="https://trustseal.enamad.ir/logo.aspx?id=433310&Code=l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
            alt=""
            style={{ cursor: "pointer" }}
            Code="l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
          />
        </a>
      </List>
    </>
  );
}

export default TopNav;
